<!-- <div class="top-group">
  <h1>Basic Update</h1>
  <a [routerLink]="['/']"> ⬅ </a>
</div> -->

<app-page-header [pageTitle]="title"></app-page-header>

<app-basic-update-chart [dataSource]="carsData"></app-basic-update-chart>

<div class="btns-group">
  <button (click)="addCar()">Add data point</button> |
  <button (click)="popCar()">Remove data point</button>
</div>

<app-basic-update-table [dataSource]="carsData"></app-basic-update-table>
